// The site is delivered by static HTML in /public/index.html.
// React remains mounted only so the platform runtime and hot reload keep working.
function App() {
  return null;
}

export default App;
